import { ConfigProps, Variants } from "./types";


export const config: ConfigProps = {
    characterLimit: 30000,
    maxSuggestions: 10,
    maxSpellcheckSuggestions: 5,
    maxSuggestionsMobile: 5,
    defaults: {
        [Variants.General]: {},
        [Variants.Valencianes]: {
            enabledRules: ["EXIGEIX_VERBS_VALENCIANS", "EXIGEIX_POSSESSIUS_U"],
            disabledRules: ["EXIGEIX_VERBS_CENTRAL", "EVITA_DEMOSTRATIUS_EIXE", "EXIGEIX_POSSESSIUS_V"]
        },
        [Variants.Balears]: {
            enabledRules: ["EXIGEIX_VERBS_BALEARS"],
            disabledRules: ["EXIGEIX_VERBS_CENTRAL", "CA_SIMPLE_REPLACE_BALEARIC"]
        }
    },
    groups: [
        {
            summary: "opcions",
            options: [
                {
                    id: "diacritics",
                    title: "Diacrítics",
                    type: "radio",
                    values: [
                        {
                            id: "diacritics_tradicional",
                            title: "Tradicionals (dóna, ós)",
                            rules: {
                                disabledCategories: ["DIACRITICS_IEC"],
                                disabledRules: ["CA_SIMPLEREPLACE_DIACRITICS_IEC"],
                                enabledRules: ["DIACRITICS_TRADITIONAL_RULES", "CA_SIMPLEREPLACE_DIACRITICS_TRADITIONAL"]
                            }
                        },
                        {
                            id: "diacritics_iec",
                            title: "IEC 2017 (dona, os)",
                            rules: {
                                disabledCategories: ["DIACRITICS_TRADITIONAL"],
                                disabledRules: ["DIACRITICS_TRADITIONAL_RULES", "CA_SIMPLEREPLACE_DIACRITICS_TRADITIONAL"],
                                enabledRules: ["CA_SIMPLEREPLACE_DIACRITICS_IEC"]
                            },
                            default: true
                        }
                    ]
                },
                {
                    id: "pronom_se",
                    title: "Pronom 'se'",
                    type: "radio",
                    values: [
                        {
                            id: "pronom_se_centra",
                            title: "'se centra'",
                            default: true,
                        },
                        {
                            id: "pronom_se_indiferent",
                            title: "'se/es centra'",
                            rules: {
                                disabledRules: ["SE_DAVANT_SC"]
                            }
                        }
                    ]
                }
            ]
        },
        {
            summary: "opcions de correcció",
            title: "Per al valencià",
            variant: Variants.Valencianes,
            options: [
                {
                    id: "opcio_general",
                    title: "Llibre d'estil",
                    type: "radio",
                    hide: true,
                    values: [
                        {
                            id: "criteris_gva",
                            title: "Criteris de l'Administració de la Generalitat",
                            link: "http://www.ceice.gva.es/documents/161863132/163843714/Criteris+Ling%C3%BC%C3%ADstics_web.pdf"
                        },
                        {
                            id: "criteris_uv",
                            title: "Criteris de les Universitats valencianes",
                            link: "https://sl.ua.es/en/assessorament/documentos/criteris-linguistics.pdf"
                        },
                        {
                            id: "criteris_cap",
                            title: "Cap",
                            default: true
                        },
                    ]
                },
                {
                    id: "incoatius",
                    title: "Verbs incoatius",
                    type: "radio",
                    values: [
                        {
                            id: "incoatius_eix",
                            title: "-eix (serveix)",
                            default: true,
                        },
                        {
                            id: "incoatius_ix",
                            title: "-ix (servix)",
                            rules: {
                                enabledRules: ["EXIGEIX_VERBS_IX"],
                                disabledRules: ["EXIGEIX_VERBS_EIX"]
                            }
                        },
                    ]
                },
                {
                    id: "incoatius2",
                    title: "",
                    type: "radio",
                    values: [
                        {
                            id: "incoatius_isc",
                            title: "-isc (servisc)",
                            default: true
                        },
                        {
                            id: "incoatius_esc",
                            title: "-esc (servesc)",
                            rules: {
                                enabledRules: ["EXIGEIX_VERBS_ESC"],
                                disabledRules: ["EXIGEIX_VERBS_ISC"]
                            }
                        },
                    ]
                },
                {
                    id: "demostratius",
                    title: "Demostratius",
                    type: "radio",
                    values: [
                        {
                            id: "demostratius_aquest",
                            title: "aquest",
                            rules: {
                                enabledRules: ["EVITA_DEMOSTRATIUS_ESTE"],
                                disabledRules: ["EVITA_DEMOSTRATIUS_AQUEST"]
                            }
                        },
                        {
                            id: "demostratius_este",
                            title: "este",
                            rules: {
                                enabledRules: ["EVITA_DEMOSTRATIUS_AQUEST"],
                                disabledRules: ["EVITA_DEMOSTRATIUS_ESTE"]
                            }
                        }
                    ]
                },
                {
                    id: "accentuacio",
                    title: "Accentuació",
                    type: "radio",
                    values: [
                        {
                            id: "accentuacio_valenciana",
                            title: "café",
                            default: true
                        },
                        {
                            id: "accentuacio_general",
                            title: "cafè",
                            rules: {
                                enabledRules: ["EXIGEIX_ACCENTUACIO_GENERAL"],
                                disabledRules: ["EXIGEIX_ACCENTUACIO_VALENCIANA"]
                            }
                        },
                    ]
                },
                {
                    id: "concorda_dues",
                    title: "Concordança",
                    type: "radio",
                    values: [
                        {
                            id: "concorda_dos_dues",
                            title: "dos/dues",
                            default: true
                        },
                        {
                            id: "concorda_dos",
                            title: "dos",
                            rules: {
                                enabledRules: ["CONCORDANCES_NUMERALS_DOS"],
                                disabledRules: ["CONCORDANCES_NUMERALS_DUES"]
                            }
                        }
                    ]
                },
                {
                    id: "municipis",
                    title: "Municipis valencians",
                    link: "https://www.avl.gva.es/municipis/",
                    type: "radio",
                    values: [
                        {
                            id: "municipi_nom_valencia",
                            title: "nom valencià",
                            default: true
                        },
                        {
                            id: "municipi_nom_oficial",
                            title: "nom oficial",
                            rules: {
                                enabledRules: ["MUNICIPIS_OFICIAL"],
                                disabledRules: ["MUNICIPIS_VALENCIA"]
                            }
                        }
                    ]
                },
                {
                    id: "lexic",
                    title: "Lèxic",
                    type: "checkbox",
                    values: [
                        {
                            id: "recomana_preferents",
                            title: "Recomana paraules i formes preferents",
                            default: true,
                            invertRules: true,
                            rules: {
                                disabledCategories: ["DNV_SECONDARY_FORM"],
                                disabledRules: ["CA_SIMPLE_REPLACE_DNV_SECONDARY", "EVITA_ISTE", "AHI", "VULLGA"]
                            }
                        },
                        {
                            id: "evita_colloquials",
                            title: "Evita paraules i formes col·loquials",
                            default: true,
                            invertRules: true,
                            rules: {
                                disabledCategories: ["DNV_COLLOQUIAL"],
                                disabledRules: ["CA_SIMPLE_REPLACE_DNV_COLLOQUIAL"]
                            }
                        }
                    ]
                }
            ]
        },
        {
            summary: "opcions de tipografia",
            title: "Tipografia",
            options: [
                {
                    id: "exigeix_tipografia",
                    type: "checkbox",
                    title: "Exigeix",
                    values: [
                        {
                            id: "espais_blancs",
                            title: "no duplicar espais en blanc (no funciona en el corrector web en línia)",
                            hide: true,
                            default: true
                        },
                        {
                            id: "prioritza_cometes",
                            title: " prioritzar cometes (« “ ‘ ’ ” »)",
                            rules: {
                                enabledRules: ["PRIORITZAR_COMETES"]
                            }
                        },
                        {
                            id: "tres_punts",
                            title: "símbol de punts suspensius (…)",
                            rules: {
                                enabledRules: ["PUNTS_SUSPENSIUS"]
                            }
                        }
                    ]
                },
                {
                    id: "apostrof",
                    title: "Apòstrof i cometes",
                    type: "radio",
                    values: [
                        {
                            id: "apostrof_tipografic",
                            title: "tipogràfics (’)",
                            rules: {
                                enabledRules: ["APOSTROF_TIPOGRAFIC", "COMETES_TIPOGRAFIQUES"],
                                disabledRules: ["APOSTROF_RECTE", "COMETES_RECTES"]
                            }
                        },
                        {
                            id: "apostrof_recte",
                            title: "rectes (')",
                            rules: {
                                enabledRules: ["APOSTROF_RECTE", "COMETES_RECTES"],
                                disabledRules: ["APOSTROF_TIPOGRAFIC", "COMETES_TIPOGRAFIQUES"]
                            }
                        },
                        {
                            id: "apostrof_indefinit",
                            title: "indefinit",
                            rules: {
                                disabledRules: ["APOSTROF_TIPOGRAFIC", "COMETES_TIPOGRAFIQUES", "APOSTROF_RECTE", "COMETES_RECTES"]
                            }
                        }
                    ]
                },
                {
                    id: "guio",
                    title: "Guió",
                    type: "radio",
                    values: [
                        {
                            id: "guio_llarg",
                            title: "llarg (—)",
                            rules: {
                                enabledRules: ["GUIO_LLARG"],
                                disabledRules: ["GUIO_MITJA"]
                            }
                        },
                        {
                            id: "guio_mitja",
                            title: "mitjà (–)",
                            rules: {
                                enabledRules: ["GUIO_MITJA"],
                                disabledRules: ["GUIO_LLARG"]
                            }
                        },
                        {
                            id: "guio_indefinit",
                            title: "indefinit",
                            rules: {
                                disabledRules: ["GUIO_MITJA", "GUIO_LLARG"]
                            }
                        }
                    ]
                },
                {
                    id: "guiopera",
                    title: "Guió per a",
                    type: "radio",
                    values: [
                        {
                            id: "guiopera_dialegs",
                            title: "diàlegs",
                            rules: {
                                enabledRules: ["GUIO_SENSE_ESPAI"]
                            }
                        },
                        {
                            id: "guiopera_enumeracions",
                            title: "enumeracions",
                            rules: {
                                enabledRules: ["GUIO_ESPAI"]
                            }
                        },
                        {
                            id: "guiopera_indefinit",
                            title: "indefinit",
                            default: true
                        }
                    ]
                },
                {
                    id: "interrogant",
                    title: "Interrogant inicial (¿)",
                    type: "radio",
                    values: [
                        {
                            id: "interrogant_mai",
                            title: "mai",
                            rules: {
                                enabledRules: ["EVITA_INTERROGACIO_INICIAL"]
                            }
                        },
                        {
                            id: "interrogant_sempre",
                            title: "sempre",
                            rules: {
                                enabledRules: ["CA_UNPAIRED_QUESTION"]
                            }
                        },
                        {
                            id: "interrogant_indefinit",
                            title: "indefinit",
                            default: true
                        }
                    ]
                },
                {
                    id: "exclamacio",
                    title: "Exclamació inicial (¡)",
                    type: "radio",
                    values: [
                        {
                            id: "exclamacio_mai",
                            title: "mai",
                            default: true,
                            rules: {
                                enabledRules: ["EVITA_EXCLAMACIO_INICIAL"]
                            }
                        },
                        {
                            id: "exclamacio_sempre",
                            title: "sempre",
                            rules: {
                                enabledRules: ["CA_UNPAIRED_EXCLAMATION"],
                                disabledRules: ["EVITA_EXCLAMACIO_INICIAL"] // TODO @jortola: crec que esta regla no fa falta
                            }
                        },
                        {
                            id: "exclamacio_indefinit",
                            title: "indefinit"
                        }
                    ]
                },
                {
                    id: "percent",
                    title: "Percentatge (%)",
                    type: "radio",
                    values: [
                        {
                            id: "percent_senseespai",
                            title: "10%",
                            default: true,
                            rules: {
                                enabledRules: ["PERCENT_SENSE_ESPAI"],
                                disabledRules: ["PERCENT_AMB_ESPAI"]
                            }
                        },
                        {
                            id: "percent_ambespai",
                            title: "10 %",
                            rules: {
                                enabledRules: ["PERCENT_AMB_ESPAI"],
                                disabledRules: ["PERCENT_SENSE_ESPAI"]
                            }
                        },
                        {
                            id: "percent_indefinit",
                            title: "indefinit",
                            rules: {
                                disabledRules: ["PERCENT_SENSE_ESPAI"]
                            }
                        }
                    ]
                },
                {
                    id: "hores",
                    title: "Hores",
                    type: "radio",
                    values: [
                        {
                            id: "hores_punt",
                            title: "11.35",
                            rules: {
                                enabledRules: ["PUNT_EN_HORES"],
                                disabledRules: ["DOSPUNTS_EN_HORES"]
                            }
                        },
                        {
                            id: "hores_dospunts",
                            title: "11:35",
                            rules: {
                                enabledRules: ["DOSPUNTS_EN_HORES"],
                                disabledRules: ["PUNT_EN_HORES"]
                            }
                        },
                        {
                            id: "hores_indefinit",
                            title: "indefinit",
                            default: true,
                            rules: {
                                disabledRules: ["DOSPUNTS_EN_HORES", "PUNT_EN_HORES"]
                            }
                        }
                    ]
                }
            ]
        }
    ]
}
